<template>
<div :class="['theme_'+$store.state.common.theme]" >
  <div class="backIndex" v-if="showback_icon">
    <img @click="backIndex" src="./assets/images/btn_back_home.png" alt="">
  </div>
  <section v-if="initializationError && !pageReady" class="initialization-error" role="alert">
    <p>页面暂时无法加载</p>
    <p>{{ initializationError }}</p>
    <button @click="retryInitialization">重新加载</button>
  </section>
  <transition :name="viewAnimate">
    <keep-alive>
      <navigation  >
        <router-view v-if="isNetworkOnline && flag" class="router_Page" v-wechat-title="$route.meta.title"/>
        <!-- <no-network v-if="!isNetworkOnline"></no-network> -->
      </navigation>
    </keep-alive>
  </transition>
</div>
</template>

<script>
// import noNetwork from '@/components/NotFound.vue';
import {
  getWapOpenId,
  getAppId,
  statistics,
  getShareInfo,
  getMarketList,
  getUserMarketInfo,
  getMeetingRoomById
} from './utils/api';
import util from './utils/util';
import storage from './utils/storage';
import { paymentReturnPath, replacePaymentRoute } from './utils/paymentReturnPath';
import {mapState,mapActions} from 'vuex';
import wx from 'weixin-js-sdk'


export default {
  name: 'App',
  components: {
    // noNetwork
  },
  data () {
    return {
      viewAnimate: '',
      isNetworkOnline: false,
      initializationError: '',
      initializationTimer: null,
      timeLate:false,
      enterTime: 0,
      leaveTime: 0,
      curTitle: '首页',
      firstLogin: 1,
      showback_icon:false,
      queryMarketId:''
    };
  },
  computed: {
    pageReady() { return this.isNetworkOnline && this.flag },
    ...mapState({
      flag: state => state.common.flag,
      common: state => state.common
    })
  },
  watch: {
    pageReady(ready) {
      if (ready) {
        clearTimeout(this.initializationTimer)
        this.initializationError = ''
      }
    },
    $route (to, from) {
      util.hideLoading()
      // 如果是安卓手机,如果需要分享好友,请求
      // if(this.timeLate)
      let u = window.navigator.userAgent;
      if(u.indexOf('Android') > -1 || u.indexOf('Adr') > -1){
        if(to.meta.share){
          wx.showOptionMenu()
          this.getShareInfo()
        }else{
          wx.ready(()=>{
            wx.hideOptionMenu()
          })
        }
      }else{
        if(to.meta.share != from.meta.share){
          if(to.meta.share){
            wx.ready(()=>{
              wx.showOptionMenu()
              wx.hideMenuItems({
                menuList: ["menuItem:openWithQQBrowser","menuItem:openWithSafari","menuItem:share:QZone","menuItem:share:weiboApp"] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮
              });
            })
          }else{
            wx.ready(()=>{
              wx.hideOptionMenu()
            })
          }
        }
      }
      // 判断是否显示回到首页按钮
      console.log(" in $routechange")
      this.getGoindex(this.common.goindex+1);
      console.log( "this.common.goindex   =====   " + this.common.goindex)
      if(this.common.goindex==0 &&
         (this.queryMarketId|| this.$route.query.cityId)&&
        this.$route.fullPath.indexOf('home') < 0 &&
        this.$route.fullPath.indexOf('/activity?') < 0 &&
        this.$route.fullPath.indexOf('/me?') < 0 &&
        this.$route.fullPath.indexOf('/evaluateSm?') < 0 &&
        !this.$route.query.come
      ){
        this.showback_icon = true
      }else{
        this.showback_icon = false
      }
      this.curTitle = to.meta.title;
       if (this.common.userId) {
          if(from.path=="/login"){ //登录页面单独记录
             var title = "登录";
             this.statistics(from.path, title)
          }
          var title1 = to.meta.recordName || to.meta.title;
          if(to.path=="/home"){
              title1 ="首页";
          }
          this.statistics(to.path, title1)
        // this.statistics(from.path, from.meta.title)
       }
      if (to.meta.index === 0 && from.meta.index === 0) {
        this.viewAnimate = '';
      }
    }
  },
  created () {
    this.armInitializationTimeout()

    this.$navigation.on('forward', () => {
      this.viewAnimate = 'slide-left'
    })
    this.$navigation.on('back', () => {
      this.viewAnimate = 'slide-right'
    })
    this.$navigation.on('replace', () => {
      this.viewAnimate = 'slide-left'
    })
    // setTimeout(() => {
    //      this.timeLate =true
    // }, 2000);
    var queryMarketId =this.$route.query.marketId
    if(this.$route.query.reserved){ //好像没用了 
      var reserved = this.$route.query.reserved
      if(!queryMarketId){
        queryMarketId = reserved
      }
      console.log('this.$route.query.reserved '+ queryMarketId)
    }
    this.queryMarketId =queryMarketId
    if(this.$route.path === '/roomDetail' && this.$route.query.id && !queryMarketId && !this.$route.query.cityId){
      this.recoverMeetingRoomMarket(this.$route.query.id)
      return
    }
    if(this.$route.query.cityId){
          this.setCityId(this.$route.query.cityId)
          this.getMarketListFun1(this.$route.query.cityId )
     }

    // 判断是否显示回到首页按钮
    if(this.common.goindex==0 &&
      (this.queryMarketId|| this.$route.query.cityId) &&//有项目id
      !this.$route.query.come &&//不是企业微信来的页面
      this.$route.fullPath.indexOf('home') < 0 &&//首页
      this.$route.fullPath.indexOf('/activity?') < 0 &&//发现页
      this.$route.fullPath.indexOf('/me?') < 0 &&//我的页面
      this.$route.fullPath.indexOf('/evaluate?') < 0 &&//评价页
      this.$route.fullPath.indexOf('/officeApproval') < 0 &&//办公耗材审批
      this.$route.fullPath.indexOf('/myAppointDetail') < 0 //家政服务订单详情-短信入口
    ){
      this.showback_icon = true
    }else{
      this.showback_icon = false
    }
    this.enterTime = new Date().valueOf()
    // 直接进入到H5页面,不请求微信接口
    if(
      this.$route.path === '/meetingApproval' ||
      this.$route.path === '/officeApproval' ||
      this.$route.path === '/myOfficeWxOrder' ||
      this.$router.path==='/shotPhoto' ||
      this.$route.path === '/myAppointDetail' && (this.$route.query.come || !this.queryMarketId) ||
      this.$route.path.indexOf('/visitAccessCard') > -1 ||
      this.$route.path.indexOf('/evaluateSm') > -1 ||
      this.$route.path.indexOf('/handleConsultation') > -1 ||
      this.$route.path.indexOf('/viewEvaluate') > -1 ||
      this.$route.path.indexOf('/WaterSignMian') > -1 ||
      this.$route.path.indexOf('/WaterSignIndex') > -1 ||
      this.$route.path.indexOf('/WaterMeetingMian') > -1 ||
      this.$route.path.indexOf('/WaterMeetingIndex') > -1
      ){
      this.getFlag(true)
      this.getShareInfo();
      return false;
    }
    // 页面刷新判断当前是否有用户数据
    let userMess = storage.getS("userData") || '';
    if(userMess){
      userMess = JSON.parse(userMess)
      var userInfo = userMess.userInfo;
      // 判断缓存的用户是否是当前项目 同一项目或者同一业主才使用缓存的用户信息
      if( (this.queryMarketId && userInfo.marketId == this.queryMarketId) || (this.$route.query.cityId && userInfo.cityId == this.$route.query.cityId) ){
          console.log('has userMess  == '  +JSON.stringify(userMess))  
         
          if(!this.$route.query.cityId){
             storage.removeS('cityId') //清除缓存城市id
             this.getUserMarketInfo(this.queryMarketId) //重新获取项目信息
          }
          this.setUserInfo()
          
          return;
      }
    }
    let href = window.location.href;
    if (href.indexOf(".com")>-1) {   //所以local 不能设置  marketId  发布的URL 里面必须带com
      let local = window.location.href;
      console.log('has .com')
      let code = storage.get('code') || '';
      // 页面刷新,取本地项目id缓存,避免刷新无效
      let marketId = storage.get('marketId') || '';
      if (!this.$route.query.code || code === this.$route.query.code) {
        console.log('nohas code')
        if(this.$route.fullPath.indexOf('home') > -1){
          if(this.$route.query.cityId){
            local = window.location.href.split('?')[0]+'?cityId='+this.$route.query.cityId
          }else{
            local = window.location.href.split('?')[0]+'?marketId='+this.queryMarketId || marketId
          }
        }
        // 先使用marketId,如果获取不到appid,再试cityId
        if(this.queryMarketId ){
          getAppId({marketId: this.queryMarketId}).then(res => {
            console.log(' getAppId +queryMarketId')
            if (res.res.code === 10000 && res.body && res.body.appid) {
              console.log(' getAppId +marketId has appid')
              window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${res.body.appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_base#wechat_redirect`;
            } else {
              if(this.$route.query.cityId){
                getAppId({cityId:this.$route.query.cityId},{cityId:this.$route.query.cityId}).then(res => {
                  if (res.res && res.res.code === 10000) {
                    if(local.indexOf('owner') == -1){
                      local = local + '&owner=1'
                    }
                    console.log(' getAppId +cityId has appid')
                    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${res.body.appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_base#wechat_redirect`;
                  } else {
                    this.getFlag(true)
                    util.showToast(res.res.msg)
                  }
                })
              }else{
                this.getFlag(true)
                util.showToast(res.res.msg)
              }
            }
          })
        }else if(this.$route.query.cityId){
          getAppId({cityId:this.$route.query.cityId},{cityId:this.$route.query.cityId}).then(res => {
            console.log(' getAppId +cityId')
            if (res.res && res.res.code === 10000) {
              window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${res.body.appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_base#wechat_redirect`;
            } else {
              this.getFlag(true)
              util.showToast(res.res.msg)
            }
          })
        }else if(marketId){ //刷新页面使用缓存的marketId
          getAppId({marketId: marketId}).then(res => {
            console.log(' getAppId +marketId')
            if (res.res && res.res.code === 10000) {
              window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${res.body.appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_base#wechat_redirect`;
            } else {
              this.getFlag(true)
              util.showToast(res.res.msg)
            }

          })

        }else{

           this.getFlag(true)
          // util.showToast('请先配置对应项目信息')

        }
      } else {
        console.log('has code')
        storage.set('code', this.$route.query.code)
        if(this.queryMarketId || marketId){
          storage.set('marketId', this.queryMarketId || marketId)
        }
        // owner=1,消息模版进来,且该项目未能获取openid
        if(this.$route.query.owner == '1'){
          this.setCityId(this.$route.query.cityId)
          storage.setS("cityId",this.$route.query.cityId)
          console.log('has owner===1 getWapOpenId')
          this.getWapOpenId({
            jsCode: this.$route.query.code,
            cityId: this.$route.query.cityId
          },{})
        }else{
          if(this.$route.query.cityId && !this.queryMarketId){
            console.log('cityId getWapOpenId')
            this.setCityId(this.$route.query.cityId)
            storage.setS("cityId",this.$route.query.cityId)
            this.getWapOpenId({
              jsCode: this.$route.query.code,
              cityId: this.$route.query.cityId
            },{})
          }else{
            console.log('else getWapOpenId')
            this.getWapOpenId({
              jsCode: this.$route.query.code,
              marketId: this.queryMarketId || marketId,
              cityId:this.$route.query.cityId || ''
            },{marketId:this.queryMarketId|| marketId})
          }
        }
      }
    } else {
      console.log('no .com')
      setTimeout(() => {
          this.$nextTick(() => {
            this.getFlag(true)
            this.isNetworkOnline =true
          })
          if(this.$route.query.cityId){
            this.setCityId(this.$route.query.cityId)
            this.getMarketListFun(this.$route.query.cityId)
          }
          storage.set('marketId','2')

          // var userData = {"openid":"oB0Dv08y-XBcnvZCQ73Om-qZBEE8"}
          // storage.setS("userData",JSON.stringify(userData))


          this.getOpenId('okABn6mrF4WR--mjeqd7BRiEdLec'); //xqrong
          // this.getMarketListFun('2')
          this.getMarketInfo({
            cityId: "2",
            cityName: "戴德梁行",
            createTime: 1567583151000,
            id: "2",
            isDrop: 0,
            isOpen: 1,
            isPushMeeting: 0,
            latitude: "31.2181710",
            longitude: "121.3594721",
            marketName: "鲁能国际",
            marketType: 1,
            styleType: 1,
            updateTime: 1582166355000,
            updateUser: "陆彬彬"
          });
         
          this.getTheme('1');
          // this.getTheme('3');
          this.getHolidayStyle('0');//设置全局节假日色
          this.getUserId('CAABC5F3D51A44428AA7B4051473260E');//xqrong
          this.getShareInfo();
          this.getUserInfo({
            account: "13681896117",
            birthday: '',
            cityId: "2",
            company: "上海彬彬科技有限公司",
           "realName":"有啥用",
            "companyId":"2998",
            "isAgree":1,
            email: "437912516@qq.com",
            faceImgUrl: "https://shsaasoss.oss-cn-shanghai.aliyuncs.com/spaceup_rst_test/1576062735132.jpg?Expires=3152862738&OSSAccessKeyId=LTAIwmjkKm3OHGdh&Signature=MU63HilPCBU%2FiLEmuht3QxUNlqw%3D",
            gender: 1,
            isDrop: 0,
            isPwd: 1,
            marketId: "2",
            memberCode: "6800967781345919075",
            modelType: 1,
            photoPath: "https://shsaasoss.oss-cn-shanghai.aliyuncs.com/spaceup_rst_test/1575774956142blob?Expires=3152574960&OSSAccessKeyId=LTAIwmjkKm3OHGdh&Signature=%2F4%2F5z%2BdnBBazToZo4f7cwk3I5Gk%3D",
            realName: "1235",
            sendToMHLM: "1",
            sendToVSH: "1",
            userId: "CAABC5F3D51A44428AA7B4051473260E",
            userName: "xqrong",
            userType: 1
          });//xqrong
          this.getTenantInfo({
           "id":"8DDAD7D36068482A817FD34DB5642959",
            "createTime":1625641378000,
            "updateTime":1625641961000,
            "updateUser":"yueyf",
            "marketId":"104",
            "cityId":"2",
            "isDrop":0,
            "userId":"CAABC5F3D51A44428AA7B4051473260E",
            "userName":"虞霜寅",
            "phone":"13681896117",
            "company":"海南海岛临空产业集团有限公司",
            "companyId":"5574",
            "source":"wx",
            "status":1,
            "isDeafult":1,
            "defaultBuild":"乌鲁克T2",
            "defaultFloor":"10层楼",
            "approvalUser":"yueyf",
            "approvalTime":1625641961000,
            "openVisitor":0,
            "synStatus":"3",
            "openYogo":0
          })
          this.getTenantInfoList([{
            "id":"8DDAD7D36068482A817FD34DB5642959",
            "createTime":1625641378000,
            "updateTime":1625641961000,
            "updateUser":"yueyf",
            "marketId":"104",
            "cityId":"2",
            "isDrop":0,
            "userId":"CAABC5F3D51A44428AA7B4051473260E",
            "userName":"虞霜寅",
            "phone":"13681896117",
            "company":"海南海岛临空产业集团有限公司",
            "companyId":"5574",
            "source":"wx",
            "status":1,
            "isDeafult":1,
            "defaultBuild":"乌鲁克T2",
            "defaultFloor":"10层楼",
            "approvalUser":"yueyf",
            "approvalTime":1625641961000,
            "openVisitor":0,
            "synStatus":"3",
            "openYogo":0
        }])
      }, 300);
      setTimeout(() => {
        this.createStatistics();
        this.getUserMarketInfo("2")
      }, 400);
    }
  },
  beforeDestroy() { clearTimeout(this.initializationTimer) },
  methods: {
    recoverMeetingRoomMarket(meetingRoomId) {
      return getMeetingRoomById({ meetingRoomId, queryDate: '' }).then(res => {
        const room = res && res.res && res.res.code === 10000 && res.body && res.body.metingRoom
        if (!room || !room.marketId) throw new Error('Meeting room market is unavailable')
        window.location.replace(paymentReturnPath(window.location.pathname + window.location.search, room.marketId))
      }).catch(() => {
        this.initializationError = '会议室信息加载失败，请稍后重试。'
      })
    },
    armInitializationTimeout() {
      clearTimeout(this.initializationTimer)
      this.initializationTimer = setTimeout(() => {
        if (!this.pageReady) this.initializationError = '页面初始化超时，请检查网络后重试。'
      }, 15000)
    },
    retryInitialization() {
      const marketId = this.queryMarketId || this.$route.query.marketId || ''
      if (!this.flag) storage.removeS('userData')
      window.location.replace(paymentReturnPath(window.location.pathname + window.location.search, marketId))
    },
    ...mapActions(['getOpenId', 'getUserInfo', 'getUserId', 'getMarketInfo', 'getFlag', 'getTheme','getHolidayStyle', 'getTenantInfo','getTenantInfoList','setCityId','getMarketList','getGoindex']),
    backIndex(){
      var url ='/home'
      if(this.$route.query.cityId){
          url = url +'?cityId=' + this.$route.query.cityId
        }
      this.$router.push(url)
    },
    getWapOpenId(params,header){
      util.showLoading()
      console.log('getWapOpenId'+ JSON.stringify(params));
      console.log('getWapOpenId'+ JSON.stringify(header));
      return getWapOpenId(params,header).then(res => {
        util.hideLoading()
          console.log(res);
          if (res.res && res.res.code === 10000 && res.body && res.body.openid) {
            storage.setS("userData",JSON.stringify(res.body))
            this.removeQueryParam('code') //移除code参数
            this.setUserInfo()
          }else{
            this.initializationError = res.res && res.res.msg || '登录信息获取失败，请重新加载。'
            util.showToast(this.initializationError)
          }
        }).catch(() => {
          util.hideLoading()
          this.initializationError = '登录信息获取失败，请检查网络后重试。'
        });
    },
    removeQueryParam(paramToRemove){
      if (!(paramToRemove in this.$route.query)) return
      const query = { ...this.$route.query }
      delete query[paramToRemove]
      return replacePaymentRoute(this.$router, { path: this.$route.path, query, hash: this.$route.hash }, false).catch(error => {
        if (error.name !== 'NavigationDuplicated') this.initializationError = '页面地址更新失败，请重新加载。'
      })
    },
    setUserInfo(){
      let userData = JSON.parse(storage.getS("userData"));
      console.log('userData ===' + JSON.stringify(userData))
      this.getShareInfo();
      this.getOpenId(userData.openid);
      if (userData.tbMarketInfo) {
        this.getMarketInfo(userData.tbMarketInfo);
        this.getTheme(userData.tbMarketInfo.styleType);//设置全局主题色
        // this.getTheme(3)
        this.getHolidayStyle(userData.tbMarketInfo.holidayStyle);//设置全局主题色
      }else{
         
      }
      if (userData.userId) {
        this.getUserId(userData.userId);
        this.createStatistics();
      }
      if(storage.getS("cityId")){
        this.setCityId(storage.getS("cityId"))
        this.getMarketListFun(storage.getS("cityId"))
      }else{
        this.getFlag(true)
      }
      if (userData.userInfo) {
        this.getUserInfo(userData.userInfo);
      }
      if (userData.userTenantInfo) {
        console.log(userData.userTenantInfo);
        this.getTenantInfo(userData.userTenantInfo);
      }
      if (userData.userTenantInfoList && userData.userTenantInfoList.length) {
        this.getTenantInfoList(userData.userTenantInfoList);
      }
    },
    createStatistics(){
        var title =this.$route.meta.title;
        var path =this.$route.path;
        if(path=="/home"){
           title ="首页";
        }
        this.statistics(path, title)
    },
    // 根据业主id获取项目信息
    getMarketListFun1(cityId){
      getMarketList({},{cityId:cityId}).then(res=>{
        console.log(' getMarketListFun1111')
        if(res.res && res.res.code === 10000 && res.body && res.body.marketList){
          let marketList = res.body.marketList || [];
          if(!marketList ||marketList.length==0){
            return 
          }
          this.getMarketList(marketList)
          let ids = [];
          marketList.forEach(item=>{
            ids.push(item.id)
          })
          // 如果缓存的项目信息不存在该业主下,删除该项目缓存
          let cityId = this.$route.query.cityId || storage.getS('cityId');
          let historyMess = JSON.parse(storage.get("historyMess"+cityId) || '[]');
          if(historyMess.length > 0){
            historyMess.forEach((item,index)=>{
              if(ids.indexOf(item.id) == -1){
                historyMess.splice(index,1)
              }
            })
            storage.set("historyMess"+cityId,JSON.stringify(historyMess))
          }
          // 判断如果是消息模版过来,且该项目没有拿到opendid,根据cityid拿到的用户数据,初始化对应的项目
          let marketItem = '';
          if(this.$route.query.owner == '1'){
            marketList.forEach(item=>{
              if(item.id == this.queryMarketId){
                marketItem = item
              }
            })
          }
          if(marketItem){
            this.getMarketInfo(marketItem)
            this.getUserMarketInfo(marketItem.id)
          }else{
            if(historyMess.length > 0){
              this.getMarketInfo(historyMess[0])
              this.getUserMarketInfo(historyMess[0].id)
            }else{
              this.getMarketInfo(marketList[0])
              this.getUserMarketInfo(marketList[0].id)
            }
          }
        }else if(res.res  && res.res.code === 10000 && res.body && !res.body.marketList){
         
        }
      })
    },
    getMarketListFun(cityId){
      getMarketList({},{cityId:cityId}).then(res=>{
        console.log('getMarketListFun')
        if(res.res && res.res.code === 10000 && res.body && res.body.marketList){
          let marketList = res.body.marketList || [];
          console.log('marketList ===   ' +(JSON.stringify(marketList)))
          if(!marketList ||marketList.length==0){
            util.showModal('提示', '贵司账号已过期，请联系项目管理员。',false,"知道了", () => {
            })
            return 
          }
          this.getMarketList(marketList)
          let ids = [];
          marketList.forEach(item=>{
            ids.push(item.id)
          })
          // 如果缓存的项目信息不存在该业主下,删除该项目缓存
          let cityId = this.$route.query.cityId || storage.getS('cityId');
          let historyMess = JSON.parse(storage.get("historyMess"+cityId) || '[]');
          if(historyMess.length > 0){
            historyMess.forEach((item,index)=>{
              if(ids.indexOf(item.id) == -1){
                historyMess.splice(index,1)
              }
            })
            storage.set("historyMess"+cityId,JSON.stringify(historyMess))
          }
          // 判断如果是消息模版过来,且该项目没有拿到opendid,根据cityid拿到的用户数据,初始化对应的项目
          let marketItem = '';
          if(this.$route.query.owner == '1'){
            marketList.forEach(item=>{
              if(item.id == this.queryMarketId){
                marketItem = item
              }
            })
          }
          if(marketItem){
            this.getMarketInfo(marketItem)
            this.getUserMarketInfo(marketItem.id)
          }else{
            if(historyMess.length > 0){
              this.getMarketInfo(historyMess[0])
              this.getUserMarketInfo(historyMess[0].id)
            }else{
              this.getMarketInfo(marketList[0])
              this.getUserMarketInfo(marketList[0].id)
            }
          }
        }else if(res.res  && res.res.code === 10000 && res.body && !res.body.marketList){
          util.showModal('提示', '贵司账号已过期，请联系项目管理员。',false,"知道了", () => {
          })
        }
      })
    },
    getUserMarketInfo(marketId){
      getUserMarketInfo({},{marketId:marketId}).then(res=>{
        console.log(res)
        if(res.res.code === 10000){
          if (res.body.tbMarketInfo) {
              this.getMarketInfo(res.body.tbMarketInfo)
              this.getTheme(res.body.tbMarketInfo.styleType);//设置全局主题色
              // this.getTheme(3)
              this.getHolidayStyle(res.body.tbMarketInfo.holidayStyle);//设置全局主题色
            }
            if (res.body.userTenantInfo) {
              this.getTenantInfo(res.body.userTenantInfo);
            }
            if (res.body.userTenantInfoList && res.body.userTenantInfoList.length) {
              this.getTenantInfoList(res.body.userTenantInfoList);
            }
            this.getFlag(true)
        }else{
          this.getFlag(true)
        }
      })
    },
    getShareInfo(){
       // console.log( wx)
       var that =this;
      // storage.getS('rootUrl') || decodeURIComponent(wx.signurl())
        var url =  storage.getS('rootUrl') || window.location.href.split('#')[0] //ios 使用缓存的 安卓使用当前的

        let u = window.navigator.userAgent;
        if(u.indexOf('Android') > -1 || u.indexOf('Adr') > -1){
          url = window.location.href.split('#')[0]
        }
       // console.log("url in getShareInfo  " + url)
        let params = {
          url:url
        }
        if(this.$route.query.cityId){
          params.cityId = this.$route.query.cityId
        }else{
          var mid = this.queryMarketId || storage.get('marketId') || this.common.marketInfo.id || ''
          params.marketId = mid
        }
        return getShareInfo(params).then(res=>{
          // // console.log( "getShareInfo  ===  " + window.location.href.split('#')[0])
          //  console.log( "getShareInfo  ===  " + JSON.stringify(res) )
           this.isNetworkOnline =true;
          if(res.res && res.res.code === 10000 && res.body&& res.body.appid){
          // util.showToast(  "   res.body.url===    " +res.body.url,60000);
          // wx.init();
           var configMap={
              debug: false,
              appId: res.body.appid , // 必填，公众号的唯一标识
              timestamp:res.body.timestamp  , // 必填，生成签名的时间戳，精确到秒
              nonceStr: res.body.nonceStr, // 必填，生成签名的随机串
              signature: res.body.signature, // 必填，签名
              openTagList: ['wx-open-subscribe'],
              jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage','updateAppMessageShareData','updateTimelineShareData','chooseImage', 'uploadImage','downloadImage','chooseWXPay','checkJsApi', 'scanQRCode','hideMenuItems','hideOptionMenu','getLocation']
           }
            wx.config(configMap)
            wx.error(function(res){
                  // util.showToast("错误信息== error   " + res.errMsg,6000);
                // 暂时解决不了 比较慢的iOS手机微信版本 获取的URL问题 所以config失败 使用当前url 再config 一次
                console.log('in error  '+ JSON.stringify(res) );
                var errMsg =  res.errMsg
                 if(errMsg.indexOf('config') > -1 ){
                  that.errorBackconfig();
                 }
            });
            wx.ready(()=>{
                if(url.indexOf('parkingService') > -1 ){ //零停缴费 不分享
                  wx.hideOptionMenu()
                }

                wx.hideMenuItems({
                  menuList: ["menuItem:openWithQQBrowser","menuItem:openWithSafari","menuItem:share:QZone","menuItem:share:weiboApp"] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮
                });
            })

          }
        }).catch(() => {
          this.initializationError = '页面初始化失败，请检查网络后重试。'
        })
    },

    //config 失败后用当前url重新config
    errorBackconfig(){
       var url =  window.location.href.split('#')[0]
       let params = {
          url:url
        }
        if(this.$route.query.cityId){
          params.cityId = this.$route.query.cityId
        }else{
          var mid = this.queryMarketId || storage.get('marketId') || this.common.marketInfo.id || ''
          params.marketId = mid
        }
        getShareInfo(params).then(res=>{
          var configMap={
              debug: false,
              appId: res.body.appid , // 必填，公众号的唯一标识
              timestamp:res.body.timestamp  , // 必填，生成签名的时间戳，精确到秒
              nonceStr: res.body.nonceStr, // 必填，生成签名的随机串
              signature: res.body.signature, // 必填，签名
              openTagList: ['wx-open-subscribe'],
              jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage','updateAppMessageShareData','updateTimelineShareData','chooseImage', 'uploadImage','downloadImage','chooseWXPay','checkJsApi', 'scanQRCode','hideMenuItems','hideOptionMenu','getLocation']
           }
            wx.config(configMap)
            wx.error(function(res){
                  // util.showToast("错误信息== error   " + res.errMsg,6000);
                  console.log('in error  '+ JSON.stringify(res) );
            });
            wx.ready(()=>{
                wx.hideMenuItems({
                  menuList: ["menuItem:openWithQQBrowser","menuItem:openWithSafari","menuItem:share:QZone","menuItem:share:weiboApp"] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮
                });
            })
        })

    },
    statistics (url, urlTypeName) {
      this.leaveTime = new Date().valueOf();
      let longTime = Math.floor((this.leaveTime - this.enterTime) / 1000)
      let firstLogin = this.firstLogin;
      if (storage.getS('firstLogin')) {
        firstLogin = 0
      }
      let params = {
        'list': [{
          urlPattern: url,
          urlTypeName: urlTypeName,
          firstLogin: firstLogin, // 1首次 0不是
          interfaceType: 4, // 4.H5 , 3.app
          longTime: longTime
        }]
      }
      statistics(params).then(() => {
        storage.setS('firstLogin', '0')
        this.enterTime = new Date().valueOf()
      })
    }
  }
};
</script>

<style lang="less">
@import "./assets/css/common.less";
html{
    background:@colore !important;
}
#app {
    margin: 0 auto;
    position: relative;
    // max-width:960px;
}
.router_Page {
    min-height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background: #fff;
}
//转场动画
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
    // -webkit-transform-style: preserve-3d;
    // -webkit-backface-visibility: hidden;
    // -webkit-perspective: 1000;
    // 启用硬件加速
    will-change: transform;
    transition: all 300ms ease-in-out;
}
.slide-right-enter {
    opacity: 0;
    transform: translate(-100%, 0);
    transition-timing-function: ease-in-out;
}
.slide-right-leave-active {
    opacity: 0;
    // 安卓手机上同时进行离开和进入会出现闪白现象，暂时不启用离开动画
    transform: translate(100%, 0);
    transition-timing-function: cubic-bezier(0.5, 0, 1, 1);
}
.slide-left-enter {
    opacity: 0;
    transform: translate(100%, 0);
    transition-timing-function: ease-in-out;
}
.slide-left-leave-active {
    opacity: 0;
    // 安卓手机上同时进行离开和进入会出现闪白现象，暂时不启用离开动画
    transition-timing-function: cubic-bezier(0.5, 0, 1, 1);
    transform: translate(-100%, 0);
}
.backIndex{
  position: fixed;
  bottom:180px;right:0;
  z-index:333;
  width:80px;
  background:rgba(255,255,255,0.7);
  box-shadow:0px 4px 8px 0px rgba(0,0,0,0.06);
  border-radius:8px 0px 0px 8px;
  border:2px solid rgba(234,234,234,1);
  border-right:0;
  img{
    display:block;
    width:44px;height:44px;
    padding:18px;
  }
}
/* Indicator */
.mint-indicator-wrapper {
    padding: 40px !important;
}
// 没有更多了
.noMore {
    margin: 40px 0;
    text-align: center;
}
.noMore_text {
    display: block;
    height: 44px;
    font-size:32px;
    color: #999;
    line-height: 44px;
}
img {
    object-fit: cover;
}
.over_two_lines{
     display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
     white-space: pre-line;
}
::-webkit-scrollbar{display:none; width:0; height: 0;background-color: transparent;}
.viewhtml {
  padding: 40px 28px;
  /deep/ strong {
    font-weight: bold;
    .fontSize(15px);
    line-height: 50px;
  }
  /deep/ p {
    .fontSize(14px);
    color: rgba(0, 0, 0, 0.9);
    line-height: 40px;
  }
  /deep/ span {
    .fontSize(14px);
    color: rgba(0, 0, 0, 0.9);
    line-height: 40px;
  }
  /deep/ img {
    max-width: 100%;
    min-width: 40%;
    margin: 10px auto;
    height: auto;
    display: block;
  }
  /deep/ figcaption {
    text-align: center;
    .fontSize(14px);
    line-height: 50px;
  }
  /deep/ tr,
  td,
  th {
    .fontSize(14px);
  }
}
</style>

<style scoped lang="less">
.initialization-error {
  padding: 120px 40px; text-align: center; font-size: 28px; line-height: 44px;
  button { margin-top: 24px; padding: 20px 40px; border: 1px solid #ddd; border-radius: 8px; background: #fff; }
}
</style>
